import zhLocale from "element-ui/lib/locale/lang/zh-CN";

const cns = {
    message: {
        topnav: {
            welcome: "欢迎您",
            customer_service: "客户服务",
            seachplaceholder: "搜索文章/用户...",
            notice: "消息",
            userindex: "我的主页",
            myindex: "我的博客",
            mygroup: "我的群吧",
            myfavorite: "我的收藏",
            mycomment: "我收到的评论",
            myqqh: "我的悄悄话",
            myfuns: "我的粉丝",
            likeme: "我收到的赞",
            profile: "我的账号",
            wxcprofile: "账号管理",
            logout: "退出登录",
            login: "登录/注册",
            admin: "运营管理",
            editbtn: "发博文",
            group_editbtn: "发帖",
            mygroupblog: "我加入的群博",
            editbtn_dropdown_0: "发文至",
        },
        blog: {
            index_menu_blog: "博客",
            menu_follow: "关注",
            menu_recommend: "精选",
            menu_hot: "热榜",
            index_title_hot: "热门博主",
            bloggerlist_refresh: "换一批",
            blogger_follow: "关注",
            blogger_remove_follow: "取消关注",
            blogger_followed: "已关注",
            notice_menu_all: "全部消息",
            notice_menu_comment: "我收到的评论",
            notice_menu_qqh: "我的悄悄话",
            notice_menu_funs: "我的粉丝",
            notice_menu_likeme: "我收到的赞",
            index_hot_categorymenu: "其它分类",
            btn_regist_now: "立即激活博客",
            blog_regist_prefix: "请点击下面按钮激活您的博客。我们会自动为您生成一个博客名:",
            blog_regist_suffix: "如果您对这个名字不满意,可以点击“我的账号”，然后再点击“博客设置”，进行修改。",
        },
        group: {
            index_menu_group: "群吧",
            index_discover: "最新群吧",
            index_title_hot: "热门群吧",
            index_article_hot: "推广置顶",
            index_hot_categorymenu: "其它分类",
            index_new_btn: "+ 新建群吧",
            my_group_add: "我加入的群吧",
            my_group_create: "我创建的群吧",
            group_add: "加入",
            group_remove_add: "退出",
            group_added: "已加入",
            group_is_private:"非公开群吧",
            group_is_open:"公开群吧",
            group_member_unit:"群员",
            group_status_title:"您的动态",
            group_todaynew_label:"今日新帖",
            group_lastmonth_label:"上月发帖",
            group_promo_label:"首页推广帖",
            member_list_label0:"待审核",
            member_list_label1:"群员",
            rule:"群规",
            summary:"群吧简介",
            info:"群吧介绍",
            discuss: "讨论",
            tag_new_btn: "添加话题",
            group_add_member: "邀请",
            group_search_pleacholder: "搜索",
            group_add_pleacholder: "按笔名搜索",
            group_create_here: "您创建的群吧会在这",
            group_added_here: "您加入的群吧会在这",
            group_status_explain:"您的动态是-您创建和加入的所有群吧的，最近帖子更新动态",
            group_hot_article_explain:"公开/非公开群吧的首页推广贴，除了该群吧首页也会出现在此列表"
        },
        groupindex: {
            left_title2: "群吧群员",
            left_btn_add: "输入名字查找想邀请的群员",
            group_blog_add_member: "邀请群员",
            group_blog_remove_member: "移除群员",
            group_blog_remove_member_alert: "确定移除该群员吗？",
            group_blog_add_pleacholder: "按笔名或邮箱",
            group_search_btn: "查询",
            group_search_opt0: "按作者",
            group_search_opt1: "按标题",
            group_search_opt2: "显示回复"
        },
        userindex: {
            bubble_iknow: "知道了",
            name_noregist: "未开通博客",
            discrib_noregist: "此用户尚未开通博客...",
            header_funs: "粉丝：",
            header_readcount: "博客访问：",
            menu_title: "博文目录",
            menu_btn_manage: "博文管理",
            article_tab0: "最新博文",
            article_tab1: "最热博文",
            article_tab2: "新评博文",
            myarticle_tab0: "博客文章",
            myarticle_tab1: "群吧帖子",
            myarticle_tab2: "评论",
            left_title2: "群博群员",
            left_btn_add: "添加作者",
            group_blog_add_member: "添加作者",
            group_blog_remove_member: "移除作者",
            group_blog_remove_member_alert: "确定移除该作者吗？",
            group_blog_add_pleacholder: "按笔名或邮箱",
        },
        article: {
            author: "作者",
            read_count: "阅读",
            edit: "编辑",
            comment_delet: "删除",
            comment_cancel: "取消",
            comment_del_confirm: "确定删除这条评论吗？",
            reply_del_confirm: "确定删除这条回复吗？",
            black_list: "加入黑名单",
            comment_placeholder: "写下您的评论...",
            reply: "回复",
            reply_count: "条回复",
            comment_button: "发表评论",
            comment_text: "评论",
            hide_text: "隐",
            group_hide_text:"非公开",
            like_text: "喜欢",
            bookmark_text: "收藏",
            share_text: "分享",
            share_wechat_text: "打开微信扫一扫[Scan QR Code]，打开网页后点击屏幕右上角分享按钮",
            share_wechat_close: "关闭",
            delete_confirm: "确定删除这篇文章吗？",
            comment_more: "加载更多评论",
            recomment_text: "相关推荐",
            post: "发表于"

        },
        setting: {
            menu_bolg: "博客设置",
            menu_accout: "账号设置",
            menu_blacklist: "黑名单",
            blog_title: "博客设置",
            blog_bgimg_btn: "修改博客背景",
            blog_name: "博客名",
            blog_name_ph: "博客名",
            blog_descript: "博客简介",
            blog_descript_ph: "博客简介",
            blog_save_btn: "保存",
            blog_saved: "已保存",
            accout_title: "账号设置",
            accout_avatar_btn: "修改我的头像",
            accout_avatar_save_btn: "确认",
            accout_cancel_btn: "取消",
            accout_name: "笔名",
            accout_name_err: "笔名不能为空",
            accout_name_ph: "笔名",
            accout_descript: "个人简介",
            accout_descript_ph: "写点什么介绍你自己吧",
            accout_country: "所在国家/地区",
            accout_accout: "登录账号",
            accout_pass: "修改密码",
            accout_pass_ph: "密码",
            accout_comfirm_ph: "确认密码",
            accout_pass_btn: "修改密码",
            black_title: "黑名单",
            black_remove: "从黑名单中移除",
            blogregist_btn: "开通博客"
        },
        editor: {
            page_title: "发博文",
            wenji_lable: "文章所属目录：",
            wenji_new_btn: "+ 新建目录",
            wenji_new_title: "新建博文目录",
            wenji_setting_title: "目录设置",
            wenji_new_placeholder: "请输入目录名称",
            wenji_new_radio1: "公开目录",
            wenji_new_radio2: "隐藏目录",
            wenji_new_error: "与现有目录名重复",
            wenji_new_cancel: "取 消",
            wenji_new_ok: "确 定",
            wenji_update_btn: "修 改",
            wenji_update_menu: "修改目录名称",
            wenji_delet_menu: "删除目录",
            wenji_comfirm_title: "确定删除博文目录 ",
            wenji_comfirm_title1: " 吗？",
            wenji_comfirm_btn: "删 除",
            wenji_cancel_btn: "取 消",
            wenji_title_suffix: " (隐)",
            group_new_title: "新建群吧",
            group_comfirm_title: "确定删除群吧 ",
            group_delet_menu: "删除群吧",
            group_new_placeholder: "請輸入群吧名称",
            group_new_error: "与现有群吧名重复",
            group_setting_title: "群吧设置",
            article_new_btn: "新建文章",
            autosaving: "自动保存中...",
            autosaved: "已自动保存",
            title_ph: "请输入博文标题",
            btn_publish: "发布博文",
            btn_update: "发布更新",
            btn_canceledit: "放弃编辑",
            canceledit_comfirm_title: "放弃编辑，将退回到您上次发布此文章的版本！是否放弃？",
            canceledit_comfirm_btn: "放 弃",
            draft_btn_save: "保存草稿",
            draft_btn_refresh: "清空草稿内容",
            draft_comfirm_text: "您要清空草稿的标题和内容吗？",
            notice: "注：发表博客文章时请不要提供广告信息或不友好信息，本站保留拒绝的权利。",
            recommend_lable: "当前博文可否评论：",
            tag_btn_add: "+ 添加内容相关关键词",
            tag_placeholder: "请输入标签",
            tag_lable: "博文标签：",
        },
        qqh: {
            modal_title_prefix: "向",
            modal_title: "发送悄悄话",
            modal_placeholder: "请输入内容",
            modal_succese: "发送成功",
            modal_btn_send: "发 送",
            modal_btn_cancel: "取 消",
            btn_send: "发悄悄话"
        }
    },
    ...zhLocale,
};
export default cns;
